<template>
  <div>
    <div v-if="!linkInvalid">
      <h1>Verifying Link...</h1>
    </div>

    <div v-if="linkInvalid">
      <h1>Link Expired or Invalid</h1>
      <p>
        It looks like this 'magic' link is expired or invalid. Please email dave@unfundedlist.com if
        this continues to happen.
      </p>
    </div>
  </div>
</template>

<script>
import Auth from '@/services/auth'
import store from '@/vuex/store'

export default {
  name: 'MagicLink',
  data() {
    return {
      linkInvalid: false,
    }
  },
  created() {
    this.$store.commit('LOGOUT_USER')
    const userId = this.$route.query.uid
    const magicToken = this.$route.query.token
    // Call endpoint with the user's ID and magic token
    Auth.magicLinkAuth(userId, magicToken)
      .then(data => {
        this.$store.commit('UPDATE_USER', {
          user: data,
          authToken: data.token,
        })
        this.$Alert.alert({
          type: 'info',
          message: `<p>Welcome to UnfundedList, ${this.$store.state.user.first_name} ${this.$store.state.user.last_name}!</p>`,
          timeout: 6000,
        })
        if (this.$store.state.user.is_staff) {
          this.$router.push({ name: 'EvaluatorsOverview' })
        } else {
          this.$router.push({ name: 'ApplicationReview' })
        }
      })
      .catch(error => {
        // On failure, show failure message
        this.linkInvalid = true
        throw error
      })
  },
}
</script>

<style lang="scss" scoped></style>
